import { DataGrid as MuiDataGrid, DataGridProps } from "@mui/x-data-grid";

export const DataGrid = (props: DataGridProps) => {
  return (
    <MuiDataGrid
      paginationMode="server"
      sortingMode="server"
      pageSizeOptions={[5, 10, 20]}
      disableRowSelectionOnClick
      {...props}
    />
  );
}; 